var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BookForm',{attrs:{"params":_vm.params,"result":_vm.result},on:{"back":_vm.onBack,"book":_vm.onBook}})}
var staticRenderFns = []

export { render, staticRenderFns }